export default __webpack_public_path__ + "static/media/ic-affiliate.0c94e2c6.svg";